import wixLocation from "wix-location";

$w.onReady(function () {
// Write your code here
});

/**
* Adds an event handler that runs when the element is clicked.
* @param {$w.MouseEvent} event
*/
$w('#bookBtn').onClick((event) => {
wixLocation.to(wixLocation.url.replace(/(?:#.*)?$/, "#book-now"));
})
 